import { post, fetch } from 'data/shared/api_utils';
import URI from "urijs";
import { isEmpty } from "lodash";

export const fetchUserSession = () => fetch('/api/security/customer');

export const hikes = () => fetch("/carto/hikes/fr");

export const AskForAccount = (data) => post('/api/security/customerBusiness', data);

export const authenticate = (data) => post('/api/security/sign-in', data);

export const fetchQuotations = (filters = {}, page) => {
    const url = new URI('/api/quotation/search/');
    url.addSearch('page', page);
    Object.keys(filters).map(name => {
        if (name == 'query') {
            url.addSearch(name, filters[name]);
        }
        else if (name == "status") {
            if (typeof filters[name] == "string") {
                url.addSearch(`filters[${name}][]`, filters[name])
            }
            else{

                filters[name].forEach(status => {
                    url.addSearch(`filters[${name}][]`, status);
                })
            }
        }
        else if (null !== filters[name]) {
            url.addSearch(`filters[${name}]`, filters[name]);
        }
    });

    return fetch(url.toString());
};

export const fetchReservations = (filters = {}, page) => {
    const url = new URI('/api/reservation/search/');
    url.addSearch('page', page);

    Object.keys(filters).map(name => {
        if (name == 'query') {
            url.addSearch(name, filters[name]);
        }
        else if (null !== filters[name]) {
            url.addSearch(`filters[${name}]`, filters[name]);
        }
    });

    return fetch(url.toString());
};

export const fetchCustomerInvoices = (filters = {}, page) => {
    const url = new URI('/api/invoice/search/');
    url.addSearch('page', page);

    Object.keys(filters).map(name => {
        if (name == 'query') {
            url.addSearch(name, filters[name]);
        }
        else if (null !== filters[name]) {
            url.addSearch(`filters[${name}]`, filters[name]);
        }
    });

    return fetch(url.toString());
};

export const checkEmail = (email) => post('/api/security/check/email', {
    email
});

export const postUser = (data) => post('/api/security/customer', data);

export const updateUser = (data) => {
    let formData = new FormData();
    Object.keys(data).forEach(key => {
        if (data[key]) {
            if (key == "country" && !isEmpty(data.country)) {
                formData.append("country[label]", data.country.label);
                formData.append("country[value]", data.country.value);
            } else {
                formData.append(key, data[key])
            }
        }
    });
    return post('/api/security/customer/update', formData);
}

export const postForgotPassword = (data) => post('/api/security/customer/password/declare-forgotten', data)

export const getCustomerHistory = (filters = {}) => {
    const url = new URI(`/api/reservation-followup/`);

    if (!isEmpty(filters)) {
        Object.keys(filters).map(key => {
            url.addSearch(key, filters[key]);
        })
    }

    return fetch(url.toString());
}

export const getHikes = (locale = 'fr') => {
    const url = new URI('/carto/hikes/' + locale);
    return fetch(url.toString());
}